// extracted by mini-css-extract-plugin
module.exports = {"container":"container--1XU5H","info":"info--2Ghn1","graphic":"graphic--2R2vK"};